import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function DatabaseSolutions() {
  return <div className="min-h-screen w-full bg-white" data-id="element-429">
      <Hero data-id="element-430" />
      <Capabilities data-id="element-431" />
      <CTA data-id="element-432" />
    </div>;
}